import { routeList } from '@/router/helpers/routes'

/* Mapping Flows Route by operationTypeId
@identifier { string, number } - payment flow or paymentTypeId
@returns { string } - route name for redirect
*/
export const operationsRouteNameMapper = identifier => {
    const route = {
        /* Payment Flows Names */
        emis_special_service: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME,
        emis_special: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME,
        emis_reference: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
        emis_service: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
        emis_voucher: routeList.PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_NAME,
        emis_refill: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFILL_NAME,
        unitel_agents: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_NAME,
        minfin_bai: routeList.PAYMENTS_SERVICES_FLOW_MINFIN_NAME,
        unitel: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_NAME,
        cajueiro: routeList.PAYMENTS_SERVICES_FLOW_CAJUEIRO_NAME,
        dstv: routeList.PAYMENTS_SERVICES_FLOW_DSTV_NAME,
        movicel: routeList.PAYMENTS_SERVICES_FLOW_MOVICEL_NAME,
        /* Transfers */
        TRANSFER: routeList.TRANSFERS_NACIONAL_NAME,
        SMART_TRANSFER: routeList.TRANSFERS_NACIONAL_NAME,
        36004: routeList.TRANSFERS_INTERNATIONAL_NAME,
        36017: routeList.TRANSFERS_INSTANT_BAI_NAME,
        /* Wallet */
        // ??: routeList.PAYMENTS_WALLET_NAME (need identifier from mdw/AF), Multicaixa not implemented yet
        /* Cards */
        CARDLESS_WITHDRAWAL: routeList.CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_NAME,
        'CRT-VISAPP': routeList.CARDS_CHARGE_DIRECT_KAMBA_NAME,
        CVISA_VIRT: routeList.CARDS_CHARGE_VIRTUAL_NAME,
        // N_PERS_EMV: routeList.CARDS_CHARGE_MULTICAIXA_NAME, Multicaixa not implemented yet
        C_FLEX_EMV: routeList.CARDS_CHARGE_FLEX_NAME,
        /* BAI PAGA */
        MOBILE_PAYMENT: routeList.PAYMENTS_BAI_PAGA_NAME
    }

    return route[identifier]
}

export const responseRouteHandler = (res, type) => {
    switch (type) {
        case 'PAYMENT':
            return operationsRouteNameMapper(res.data.data.paymentsOperator.flow)
        case 'INTERNATIONAL_TRANSFER':
            return operationsRouteNameMapper(res.data.data.internationalTransferProcessView.customerOperation.operationType.id)
        case 'PRE_PAID_CREDIT_CARD_TOP_UP':
        case 'PRE_PAID_CREDIT_CARD_TOP_UP_EXTERNAL':
        case 'PRE_PAID_CARD_TOP_UP_EXTERNAL':
            return operationsRouteNameMapper(res.data.data.prePaidExternalCardTopup.card.productExternalId)
        default:
            return operationsRouteNameMapper(type)
    }
}

export const iconMapper = type => {
    const menuIcons = {
        TRANSFER: 'transfer',
        PAYMENT: 'payment-single',
        CARDLESS_WITHDRAWAL: 'credit-card',
        INTERNATIONAL_TRANSFER: 'transfer',
        PRE_PAID_CREDIT_CARD_TOP_UP: 'credit-card',
        SMART_TRANSFER: 'transfer',
        PRE_PAID_CREDIT_CARD_TOP_UP_EXTERNAL: 'credit-card',
        PRE_PAID_CARD_TOP_UP_EXTERNAL: 'credit-card',
        MOBILE_PAYMENT: 'payment-single'
    }

    return menuIcons[type] || null
}
